export default "__VITE_ASSET__BSjEiVSv__"